import SectionComponent from "./sectionComponent"

export default SectionComponent
